var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "share-network-container"
  }, [_c('div', {
    staticClass: "mr-1 mr-lg-3 mr-xl-3"
  }, [_c('font-awesome-icon', {
    attrs: {
      "id": 'tooltip-copy-' + _vm._uid,
      "size": "1x",
      "icon": "link"
    },
    on: {
      "click": _vm.onCopyLink
    }
  }), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": 'tooltip-copy-' + _vm._uid
    }
  }, [_vm._v(" " + _vm._s(_vm.linkCopyText) + " ")])], 1), _c('div', {
    staticClass: "mr-1 mr-lg-3 mr-xl-3"
  }, [_c('ShareNetwork', {
    attrs: {
      "network": "linkedin",
      "url": _vm.url,
      "title": _vm.title
    }
  }, [_c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "size": "2x",
      "icon": ['fab', 'linkedin'],
      "id": "linkedin-icon"
    }
  }), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "linkedin-icon"
    }
  }, [_vm._v(" Share on LinkedIn ")])], 1)], 1), _c('div', {
    staticClass: "mr-1 mr-lg-3 mr-xl-3"
  }, [_c('ShareNetwork', {
    attrs: {
      "network": "twitter",
      "url": _vm.url,
      "title": _vm.title,
      "description": _vm.description
    }
  }, [_c('img', {
    staticClass: "x-twtter-logo",
    attrs: {
      "alt": "twitter log",
      "src": require("../assets/images/logo/X_logo_2023_original.svg"),
      "id": "twitter-icon"
    }
  }), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "twitter-icon"
    }
  }, [_vm._v(" Share on Twitter ")])], 1)], 1), _c('div', {
    staticClass: "mr-1 mr-lg-3 mr-xl-3"
  }, [_c('ShareNetwork', {
    attrs: {
      "network": "facebook",
      "url": _vm.url,
      "title": _vm.title,
      "description": _vm.description
    }
  }, [_c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "id": "facebook-icon",
      "size": "2x",
      "icon": ['fab', 'facebook-square']
    }
  }), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "facebook-icon"
    }
  }, [_vm._v(" Share on Facebook ")])], 1)], 1), _c('div', {
    staticClass: "mr-1 mr-lg-3 mr-xl-3"
  }, [_c('ShareNetwork', {
    attrs: {
      "network": "reddit",
      "url": _vm.url,
      "title": _vm.title,
      "description": _vm.description
    }
  }, [_c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "id": "reddit-icon",
      "size": "2x",
      "icon": ['fab', 'reddit-square']
    }
  }), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "reddit-icon"
    }
  }, [_vm._v(" Share on Reddit ")])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }